export enum DesignableObjectCreationMethod {
    DESERIALIZING = "D",
    CLONING = "C",
    NORMAL = "N"
}
